const getRootDomain = () => {
  const hostname = window.location.hostname;
  const parts = hostname.split(".");

  if (parts.length >= 2) {
    return parts.slice(-2).join(".");
  }

  return hostname;
};

export const ROOT_DOMAIN = getRootDomain();
